import React from 'react';

import { StyledAvatar } from 'components/avatars';
import Select, { components } from 'react-select';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { FEEDBACK_FORM_VISIBILITY } from 'constants/ProjectConstants';
import { getColorFromKey } from 'constants/helper';
import { PublicViewIcon, PrivateViewIcon, PrivateManagerViewIcon, ManagerViewIcon } from 'constants/icons';

// used to display Icon
export const VisibilityIconPack = {
  PublicViewIcon: <PublicViewIcon />,
  PrivateViewIcon: <PrivateViewIcon />,
  PrivateManagerViewIcon: <PrivateManagerViewIcon />,
  ManagerViewIcon: <ManagerViewIcon />,
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const GreyStyledAvatar = styled(StyledAvatar)`
  background: white;
  color: ${(props) => getColorFromKey(props.color)};

  svg {
    fill: ${(props) => getColorFromKey(props.color)};
  }
`;

function IconOption(props) {
  const { data } = props;
  const { Option } = components;
  return (
    <Option {...props}>
      <StyledContainer>
        <GreyStyledAvatar color="textSecondary" display="inline" size="tiniest">
          {VisibilityIconPack[data.icon]}
        </GreyStyledAvatar>
        <StyledTypography display="inline" leftGutter={1}>
          {data.label}
        </StyledTypography>
      </StyledContainer>
    </Option>
  );
}

function SingleValueIcon(props) {
  const { data } = props;
  const { SingleValue } = components;
  return (
    <SingleValue {...props}>
      <StyledContainer>
        <GreyStyledAvatar color="textSecondary" display="inline" size="tiniest">
          {VisibilityIconPack[data.icon]}
        </GreyStyledAvatar>
        <StyledTypography display="inline" leftGutter={1}>
          {data.label}
        </StyledTypography>
      </StyledContainer>
    </SingleValue>
  );
}

const SelectVisibility = ({
  onChange,
  disabled = false,
  value = FEEDBACK_FORM_VISIBILITY[0],
  options = FEEDBACK_FORM_VISIBILITY,
}) => (
  <Select
    isDisabled={disabled}
    value={value}
    options={options}
    components={{ Option: IconOption, SingleValue: SingleValueIcon }}
    onChange={onChange}
  />
);

export default SelectVisibility;
